import { UI } from '@genial/components';

export type ProductTabs = {
  title: string;
  disabled?: boolean;
};

interface TabsProps {
  productsTabs: ProductTabs[];
  selectedTabIndex: number;
  loading: boolean;
  isMobile?: boolean;
  handleChangeTab: (tabIndex: number) => void;
}

export const Tabs = ({
  selectedTabIndex,
  handleChangeTab,
  productsTabs,
  loading,
  isMobile,
}: TabsProps) => {
  if (isMobile) {
    return null;
  }

  return (
    <UI.Tabs
      testId="assets-tabs"
      activeTab={selectedTabIndex}
      onTabPress={handleChangeTab}
      tabs={productsTabs}
      isLoading={loading}
    />
  );
};
